"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _BaseIntervalFrequency = _interopRequireDefault(require("../BaseIntervalFrequency"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var AsNeededFrequency = /*#__PURE__*/function (_BaseIntervalFrequenc) {
  _inherits(AsNeededFrequency, _BaseIntervalFrequenc);

  var _super = _createSuper(AsNeededFrequency);

  function AsNeededFrequency() {
    _classCallCheck(this, AsNeededFrequency);

    return _super.apply(this, arguments);
  }

  _createClass(AsNeededFrequency, [{
    key: "addIntervals",
    value: function addIntervals(startDate, operand) {
      var newDate = new Date(startDate);
      newDate.setDate(startDate.getDate() + operand);
      return newDate;
    }
  }, {
    key: "subtractIntervals",
    value: function subtractIntervals(startDate, operand) {
      var newDate = new Date(startDate);
      newDate.setDate(startDate.getDate() - operand);
      return newDate;
    }
  }, {
    key: "getStartOfInterval",
    value: function getStartOfInterval(date) {
      var start = new Date(date.getTime());
      start.setHours(0, 0, 0, 0);
      return start;
    }
  }, {
    key: "getWarningDateForUpcomingTasks",
    value: function getWarningDateForUpcomingTasks(baseDate) {
      var advanceNoticeDate = new Date(baseDate.getTime());
      advanceNoticeDate.setUTCDate(advanceNoticeDate.getUTCDate() - 1);
      return advanceNoticeDate;
    }
  }, {
    key: "toString",
    value: function toString() {
      return 'As Needed';
    }
  }]);

  return AsNeededFrequency;
}(_BaseIntervalFrequency["default"]);

exports["default"] = AsNeededFrequency;